module.exports = __webpack_public_path__ + "img/fangkeyuyue.cba7074b.png";